import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_298: DocMigration = {
  maxSchemaVersion: "0.0.298",
  description: "Add new overhang datum anchor to Roof Settings",
  apply(json: any) {
    let hasRoofSettings = false;
    for (const settingsId in json.settings) {
      const setting = json.settings[settingsId];

      if (setting.type !== "ROOF_SETTINGS") {
        continue;
      }
      hasRoofSettings = true;
      json.settings[settingsId] = {
        ...json.settings[settingsId],
        overhangDatum: "OUTSIDE_FACE_OF_SUBSTRATE",
      };
    }
    if (!hasRoofSettings) {
      const settingsSetId = uid();
      const settingsSet = {
        entityType: "SETTINGS_SET",
        name: "Roof Settings Set",
        type: "GLOBAL",
        id: settingsSetId,
        sortIndex: 0,
      };
      if (!json.settingsSets) {
        json.settingsSets = {};
      }
      json.settingsSets[settingsSetId] = settingsSet;
      const settingsId = uid();
      const roofSettings = {
        id: settingsId,
        type: "ROOF_SETTINGS",
        name: "Roof Settings",
        parentId: settingsSetId,
        entityType: "SETTINGS",
        sortIndex: 0,
        overhangDatum: "OUTSIDE_FACE_OF_SUBSTRATE",
      };
      json.settings[settingsId] = roofSettings;
    }

    return json;
  },
};

export default migration_0_0_298;
